import { GlobalConfig } from 'ngx-toastr';


export const TOASTER_CONFIG: Partial<GlobalConfig> = {
  timeOut: 5000,
  positionClass: 'toast-bottom-right',
  preventDuplicates: false
};
